import React, { useState, useEffect } from 'react';
import { getLastLogin } from '../services/api';

const LastLogin = ({ userId }) => {
  const [lastLogin, setLastLogin] = useState(null);

  useEffect(() => {
    const fetchLastLogin = async () => {
      try {
        const response = await getLastLogin(userId);
        setLastLogin(response.data);
      } catch (error) {
        console.error('Error fetching last login:', error);
      }
    };

    fetchLastLogin();
  }, [userId]);

  return (
    <div>
      <h3>Last Login</h3>
      {lastLogin ? (
        <p>Last login time: {new Date(lastLogin).toLocaleString()}</p>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default LastLogin;